var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"build",class:'no'+_vm.type},[_c('div',[_vm._v(_vm._s(_vm.text)+"\n    "),(_vm.type=='cart')?_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.goto(_vm.type)}}},[_vm._v("继续购物")]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60ca6c8d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nonull.vue
// module id = null
// module chunks = 